// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"style-module__cardContainer___2J1wn","boxShadow":"style-module__boxShadow___23bfF"};